import { Menu } from '~/modules/Elements/AKUI/Menu';

export const MenuButton = Menu.Button;
export const MenuContainer = Menu;
